const JOB_BOOST = "JOB_BOOST";

const BOOST_EVENTS = {
  BOOST_CLICKED: {
    name: "BOOST_CLICKED",
    category: JOB_BOOST
  },
  BOOST_CONFIRMATION_DISMISS: {
    name: "BOOST_CONFIRMATION_DISMISS",
    category: JOB_BOOST
  },
  BOOST_POPUP_CTA_CLICKED: {
    name: "BOOST_POPUP_CTA_CLICKED",
    category: JOB_BOOST
  },
  BOOST_SUCCESS_SHOWN: {
    name: "BOOST_SUCCESS_SHOWN",
    category: JOB_BOOST
  },
  BOOST_NOT_ALLOWED_SHOWN: {
    name: "BOOST_NOT_ALLOWED_SHOWN",
    category: JOB_BOOST
  },
  BOOST_LANDING_OK: {
    name: "BOOST_LANDING_OK",
    category: JOB_BOOST
  },
  BOOST_LANDING_CLOSE: {
    name: "BOOST_LANDING_CLOSE",
    category: JOB_BOOST
  }
};
export default BOOST_EVENTS;
